import { render } from "./AboutPopup.vue?vue&type=template&id=696f8c5a&scoped=true"
import script from "./AboutPopup.vue?vue&type=script&lang=js"
export * from "./AboutPopup.vue?vue&type=script&lang=js"

import "./AboutPopup.vue?vue&type=style&index=0&id=696f8c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696f8c5a"]])

export default __exports__